import { AxiosRequestConfig } from 'axios';
import { UpdateEmailPayload } from './account.types';

class AccountRequestConfig {
  updateEmail = (data: UpdateEmailPayload): AxiosRequestConfig => ({
    method: 'PATCH',
    url: 'account',
    data
  });

  getUserInfo = (): AxiosRequestConfig => ({
    method: 'GET',
    url: 'account/roles'
  });

  getMapSettings = (): AxiosRequestConfig => ({
    method: 'GET',
    url: 'account/GetMapSettings'
  });
}

export const accountRequestConfig = new AccountRequestConfig();
